import BrunchUserAgent from '@services/BrunchUserAgent';

if (jQuery) {
    jQuery.noConflict();
    jQuery.userAgent = daumtools.userAgent();
} else {
    alert('jQuery를 로드해주세요');
}

window.B = {
    version: '0.1',

    cookie: {
        firstPublishShare: 'firstPublishShare',
        firstDraftSave: 'firstDraftSave',
        firstBrunchbookPublishShare: 'bp_pub'
    },

    preSettings: {
        'minScrollWidth': 940
    },

    localStorageKey: {
        viewArticleUid: 'viewArticleUid',
        referrer: 'listViewReferrer',
        feed: {
            listData: 'feedArticleList',
            clickArticleUid: 'feedClickArticleUid',
            lastTime: 'feedLastCreateTimeParam'
        },
        feed_magazine: {
            listData: 'feedMagazineList',
            clickArticleUid: 'feedClickMagazineUid',
            lastTime: 'feedMagazineLastCreateTimeParam'
        },
        feed_following: {
            listData: 'feedFollowingList',
            clickArticleUid: 'feedClickFollowingUid',
            lastTime: 'feedFollowingListLastCreateTimeParam'
        },
        home: {
            listData: 'homeArticleList',
            clickArticleUid: 'homeClickArticleUid',
            lastTime: 'homeLastCreateTimeParam'
        },
        home_image: {
            listData: 'homeArticleImageTypeList',
            clickArticleUid: 'homeClickArticleImageTypeUid',
            lastTime: 'homeImageTypeLastCreateTimeParam'
        },
        magazine: {
            listData: 'magazineArticleList',
            clickArticleUid: 'magazineClickArticleUid',
            lastTime: 'magazineLastCreateTimeParam'
        },
        now: {
            listData: 'nowArticleList',
            clickArticleUid: 'nowClickArticleUid',
            lastTime: 'nowLastCreateTimeParam'
        },
        likeit: {
            article: {
                listData: 'likeitArticleList2',
                lastTime: 'likeitArticleLastCreateTimeParam2',
                clickUid: 'likeitArticleClickUid2',
                moreList: 'likeitArticleMoreList2'
            },
            magazine: {
                listData: 'likeitMagazineList2',
                lastTime: 'likeitMagazineLastCreateTimeParam2',
                clickUid: 'likeitMagazineClickUid2',
                moreList: 'likeitMagazineMoreList2'
            }
        },
        pod: {
            visit: 'pod_visit'
        },
        search: {
            queries: 'searchQueries'
        },
        brunchbook: {
            lastViewArticle: {
                listData: 'lastViewArticleForBrunchbook'
            }
        }
    },

    UserAgent: BrunchUserAgent(),

    headerMenu: {
        $serviceHeader: jQuery('.service_header'),
        $btnSearch: jQuery('#btnServiceMenuSearch'),
        $searchQuery: jQuery('#searchQuery'),
        $btnToggleArticleMoreAction: jQuery('#btnToggleArticleMoreAction'),
        $writeButton: jQuery('.service_header .btn_write'),
        classNames: {
            headerHeadMenubar: 'header_head_menubar',
            scrollBeyond: 'beyond_content',
            toggleArticleMoreAction: 'show_more_action'
        },

        init: function () {
            this.$btnSearch.on('click', jQuery.proxy(this.showSearchArea, this));
        },

        showSearchArea: function (e) {
            var $button = jQuery(e.target);

            if (location.pathname != '/') {
                var $input = this.$searchQuery;

                if ($button.parent().hasClass('show')) {
                    this.$searchQuery.focus();
                    return false;
                }

                this.animateForm($button, $input);
            } else {
                B.searchLayer.init();
            }
        },

        animateForm: function ($button, $input) {
            jQuery('#searchQuery').css('opacity', '0');
            $button.parent().addClass('show');
            this.$writeButton.addClass('show');
            $button.css('margin-right', '17px');
            $input.css('margin-left', '80px');
            $button.animate({
                'margin-right': 172 + 'px'
            }, 200,
            function () {
                jQuery('#searchQuery').css('opacity', '1');
            }
            );
            $input.animate({
                'margin-left': 37 + 'px'
            }, 300,
            function () {
            }
            );
            this.$searchQuery.focus();
        },

        initArticleMoreAction: function () {
            this.$btnToggleArticleMoreAction.on('click', jQuery.proxy(this.toggleArticleMoreActionClassName, this));
            jQuery('#btnEditBrunchbookArticle').on('click', jQuery.proxy(B.Article.editBrunchbookArticle, B.Article));
            jQuery('#btnDeleteArticle').on('click', jQuery.proxy(B.Article.deleteArticle, B.Article));
            jQuery('#btnPrivateArticle').on('click', jQuery.proxy(B.Article.privateArticle, B.Article));
            jQuery('#btnPublishArticle').on('click', jQuery.proxy(B.Article.clickPublishButton, B.Article));
            jQuery('#btnCancleArticle').on('click', jQuery.proxy(B.Article.clickCancelReservationButton, B.Article));

            jQuery('.wrap_action_article .more_action_wrap')
                .on('transitionend', function () {
                    B.headerMenu.toggleForDefaultActionWrap(jQuery(this), 'hidden');
                })
                .on('transitionstart', function () {
                    B.headerMenu.toggleForDefaultActionWrap(jQuery(this), 'visible');
                });
        },

        toggleForDefaultActionWrap: function ($target, visibility) {
            var hasShowMoreAction = $target.closest('.wrap_action_article')
                .hasClass('show_more_action');

            var $defaultActionWrap = $target.parent()
                .find('.default_action_wrap');

            if (visibility === 'hidden') {
                if (hasShowMoreAction) {
                    $defaultActionWrap.css({
                        visibility: visibility
                    });
                }
            } else if (visibility === 'visible') {
                if (!hasShowMoreAction) {
                    $defaultActionWrap.css({
                        visibility: visibility
                    });
                }
            }
        },

        toggleArticleMoreActionClassName: function () {
            this.$btnToggleArticleMoreAction
                .parent()
                .toggleClass(this.classNames.toggleArticleMoreAction);
        },

        initScrollMenuForPage: function (menubarType) {
            jQuery(window).on('scroll', jQuery.proxy(this.controlScroll, this, menubarType));
        },

        controlScroll: function (menubarType) {
            var headerClassTypeObj = { home: 1, ready: 1, history: 1, setting: 1, stats: 1, feed: 1, search: 1, magazine: 1, now: 1, likeit: 1, apply: 1, propose: 1 };

            if (menubarType in headerClassTypeObj) {
                var contentY = jQuery('.' + this.classNames.headerHeadMenubar).height();
            }

            if (menubarType == 'subscription') {
                var contentY = jQuery('.header_head_menubar').offset().top;
            }

            if (menubarType == 'likeUsers' || menubarType == 'bookPrize') {
                var contentY = jQuery('.header_head_menubar').offset().top;
            }

            if (menubarType == 'write') {
                var contentY = jQuery('.wrap_cover').height();
            }

            if (menubarType == 'stats') {
                var contentY = jQuery('.cont_statistic').offset().top;
            }

            if (menubarType == 'search') {
                var contentY = jQuery('.cont_search').offset().top;
            }

            if (menubarType == 'top') {
                var contentY = jQuery('.editor_pic').offset().top;
            }

            if (menubarType == 'brunchbookEntry') {
                var contentY = jQuery('.cont_brunchbook_entry').offset().top;
            }

            if (menubarType == 'keywordSub') {
                var contentY = jQuery('.wrap_contents').offset().top;
            }

            if (menubarType == 'publish') {
                var contentY = jQuery('.wrap_list_award').offset().top;
            }

            if (menubarType == 'apply') {
                var contentY = 10;
            }

            if (jQuery(window).scrollTop() > contentY) {
                this.$serviceHeader.addClass(this.classNames.scrollBeyond);

                if (menubarType == 'search') jQuery('.wrap_btn_search').addClass('show');

                if (menubarType == 'search') jQuery('#btnServiceMenuSearch').css('margin-right', '172px');

                if (menubarType == 'publish') {
                    jQuery('.book_request').removeClass('book_request_link');
                }

                if (menubarType == 'apply') {
                    this.$serviceHeader.removeClass('white_header');
                }
            } else {
                this.$serviceHeader.removeClass(this.classNames.scrollBeyond);

                if (menubarType == 'search') jQuery('.wrap_btn_search').removeClass('show');

                if (menubarType == 'search') jQuery('#btnServiceMenuSearch').css('margin-right', 0);

                if (menubarType == 'publish') {
                    jQuery('.book_request').addClass('book_request_link');
                }

                if (menubarType == 'apply') {
                    this.$serviceHeader.addClass('white_header');
                }
            }
        }
    },

    sideMenu: {
        $serviceHeader: jQuery('.service_header'),
        $btnServiceMenu: jQuery('#btnServiceMenu'),
        $wrapSideMenu: jQuery('#wrapSideMenu'),
        $btnCloseSideMenu: jQuery('#btnCloseSideMenu'),
        $brunchIgnoreSigninButtonWhenConfirm: jQuery('#brunchIgnoreSigninButtonWhenConfirm'),

        init: function () {
            this.$btnServiceMenu.on('click', jQuery.proxy(this.openSideMenu, this));
            this.$btnCloseSideMenu.on('click', jQuery.proxy(this.closeSideMenu, this));
            this.$brunchIgnoreSigninButtonWhenConfirm.on('click', jQuery.proxy(this.closeSideMenu, this));
            jQuery(window).on('resize load', jQuery.proxy(this.resizeMenuHeight, this));
            jQuery(window).on('keydown', jQuery.proxy(this.keydownHandler, this));
            jQuery(window).on('mousedown touchend', jQuery.proxy(this.mousedownHandler, this));
            this.initSetLoginOutUrl();
            this.checkNewAlert();
            this.initRemoveLocalStorageData();
        },

        openSideMenu: function () {
            this.$wrapSideMenu.addClass('open');

            T.newPage()
                .setSection('menu')
                .setPage('menu')
                .setActionKind('ViewContentList')
                .setName('메뉴')
                .track();
        },

        closeSideMenu: function () {
            this.$wrapSideMenu.removeClass('open');
        },

        initSetLoginOutUrl: function () {
            var locationPath = location.pathname;
            var returnUrl = '/signin?url=' + encodeURIComponent(locationPath);

            if (/^\/search/.test(locationPath)) {
                var searchParam = location.search;

                if (searchParam) {
                    returnUrl = '/signin?url=' + encodeURIComponent(locationPath + searchParam);
                }
            }

            jQuery('#sideMenuLogoutButton').attr('href', '/kakao/logout');

        },

        resizeMenuHeight: function (e) {
            var windowHeight = jQuery(window).height();
            var $wrap = jQuery('#wrapSideMenu .wrap_side_service_menu');
            var $setting = jQuery('#wrapSideMenu .wrap_side_setting');
            var $profile = jQuery('#wrapSideMenu .wrap_side_profile');

            var wrapHeight = 417; // wrap 컨텐츠 영역의 고정 높이 값. wrap 영역은 스크롤을 위해 동적으로 높이를 변경 하기 때문에 초기 고정 값으로 계산을 하도록 함.
            var settingHeight = $setting.height();
            var profileHeight = $profile.height();
            var menuHeight = profileHeight + wrapHeight + settingHeight;

            // 메뉴의 높이가 브라우저 화면 높이보다 높은 경우 스크롤을 만들기 위해 스타일을 수정 한다.
            if (menuHeight > windowHeight) {
                $setting.css('position', 'inherit');
                var height = windowHeight - profileHeight - 30; // 높이값 계산시 , 메뉴에서 프로필 영역 높이 , 하단 바텀의 높이를 뺀 값으로 설정 한다.
                $wrap.height(height);
            } else {
                $setting.css('position', 'absolute');
            }
        },

        keydownHandler: function (e) {
            // ESC keyCode is 27
            if (e && e.keyCode && e.keyCode == 27) {
                this.closeSideMenu();
            }
        },

        mousedownHandler: function (e) {
            var $target = jQuery(e.target);

            if ($target.closest('#wrapSideMenu').length == 0) {
                this.closeSideMenu();
            }
        },

        checkNewAlert: function () {
            if (!(B.User && B.User.userId) || window.location.href.indexOf('/me/history') > -1) return;

            var self = this;
            B.Util.ajax({
                xhrFields: {
                    withCredentials: true
                },
                crossDomain: true,
                type: 'GET',
                url: B.Config.apiUrl + '/v1/history/new',
                success: function (r) {
                    if (r.data && r.data.count > 0) {
                        self.showNewAlert();
                    } else {
                        self.hideNewAlert();
                    }
                },

                error: function (err) {
                    console.error(err);
                    return true;
                }
            });
        },

        hideNewAlert: function () {
            this.$serviceHeader.removeClass('new');
            this.$btnServiceMenu.removeClass('new');
            this.$wrapSideMenu.removeClass('new');
        },

        showNewAlert: function () {
            this.$serviceHeader.addClass('new');
            this.$btnServiceMenu.addClass('new');
            this.$wrapSideMenu.addClass('new');
        },

        initRemoveLocalStorageData: function () {
            jQuery('.wrap_side_service_menu .brunchHomeLink').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.home.listData);
            });
            jQuery('.wrap_side_service_menu .brunchHomeLink').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.home_image.listData);
            });
            jQuery('.wrap_side_service_menu .brunchFeedLink').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.feed.listData);
            });
            jQuery('.wrap_side_service_menu .brunchNowLink').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.now.listData);
            });
            jQuery('.wrap_side_service_menu .brunchLikeLink').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.likeit.listData);
            });
            jQuery('#sideMenuLogoutButton').on('click', function () {
                B.Util.localStorage.remove(B.localStorageKey.brunchbook.lastViewArticle.listData);
            });
        }

    },

    searchLayer: {
        $body: jQuery('body'),
        layerTypeGuide: 'layer_guide',
        layerTypeSearch: 'layer_search',
        searchTypes: ['article', 'magazine', 'user'],
        typing: '',
        lastQuery: '',

        initElement: function () {
            jQuery.extend(this, {
                $layer: jQuery('#searchLayer'),
                $sideMenu: jQuery('#wrapSideMenu'),
                $searchGuide: jQuery('#suggestGuide'),
                $searchTitle: jQuery('#suggestSearch .tit_suggest a'),
                $searchInput: jQuery('.wrap_search .search_form #txt_search'),
                $searchBtn: jQuery('#btnServiceMenuSearch .ico_search'),
                $logo: jQuery('#searchLayer .btn_close, #searchLayer .logo_service'),
                $guideTxt: jQuery('.suggest_guide p.desc_g'),
                $menuBtn: jQuery('#searchLayer #btnServiceMenu')
            });
        },

        init: function () {
            var _this = this;
            jQuery.get(B.Config.apiUrl + '/v1/search/guide', function (r) {
                T.newPage()
                    .setSection('search')
                    .setPage('common')
                    .setName('검색 > 기본 화면')
                    .track();

                r.data.guideText = r.data.guideText;

                if (_this.$layer == null || typeof _this.$layer == 'undefined') {
                    _this.$body.prepend(jQuery(B.Util.getTemplate('search-pc-intro.hbs', r.data)));
                    _this.$body.find('.wrap_list').append(jQuery(B.Util.getTemplate('search-pc-intro-recommends.hbs', r.data)));
                    _this.$body.addClass('brunch_suggest');
                    _this.initElement();
                    _this.$logo.on('click', jQuery.proxy(_this.downSearchArea, _this));
                    _this.$guideTxt.html(r.data.guideText);
                    _this.$layer.addClass(_this.layerTypeGuide);
                    _this.initLive();
                    _this.$body.prepend(_this.$body.find('#wrapSideMenu'));
                    _this.$menuBtn.on('click', function () {
                        _this.$sideMenu.addClass('open');
                    });
                    jQuery('.recmd_keyword').each(function () {
                        jQuery(this).on('click', function (e) {
                            e.preventDefault();

                            var keyword = jQuery(this).text();
                            location.href = '/search?q=' + encodeURIComponent(r.data.guideQuery) + '&k=' + encodeURIComponent(keyword) + '&type=user';

                            T.newSearch()
                                .setName('검색 > 추천 검색어 클릭')
                                .setActionKind('Search')
                                .setSearchTerm(keyword)
                                .setSearchType('suggest')
                                .track();
                        });
                    });
                }
            });
        },

        initLive: function () {
            var _this = this;
            this.$searchInput.on('keyup', function (e) {
                e.preventDefault();
                var _q = jQuery('#txt_search').val().trim();
                var _thisInput = jQuery(this);

                if (_q == '') {
                    _thisInput.css('background-color', 'transparent');
                } else {
                    _thisInput.css('background-color', '#fff');
                }

                if (!_this.$layer.hasClass(_this.layerTypeSearch)) {
                    _this.$layer.addClass(_this.layerTypeSearch);
                    _this.$layer.removeClass(_this.layerTypeGuide);
                }

                if (e.keyCode == 13 && _q != '') {
                    _this.$searchBtn.click();
                } else {
                    _this.typing = setTimeout(function () {
                        if (_this.lastQuery != _q) {
                            _this.liveSearch(_q, _this);
                        }

                        _this.lastQuery = _q;
                    }, 200);
                }
            });
            this.$searchInput.on('keydown', function (e) {
                clearTimeout(_this.typing);
            });
            this.$searchBtn.on('click', jQuery.proxy(this.moveToSearch, this));
            this.$searchTitle.on('click', function (e) {
                e.preventDefault();
                _this.moveToSearch(jQuery(this).data('type'));
            });
            this.initSearchInput();
        },

        initSearchInput: function () {
            var $placeholder = this.$searchInput.clone().addClass('placeholder').val(this.$searchInput.attr('placeholder'));
            var $placeContainer = jQuery('<span class="placeholder-container"></span>');
            $placeContainer.insertAfter(this.$searchInput).append(this.$searchInput).append($placeholder);
            $placeContainer.css({
                position: 'relative'
            });
            this.$searchInput.css({
                position: 'absolute',
                zIndex: 10,
                backgroundColor: 'transparent',
                borderColor: 'transparent'
            });
            $placeholder.css('color', 'transparent');
            this.$searchInput.focus(function () {
                var $input = jQuery(this);
                jQuery('.placeholder', $input.parent()).css('color', '#fbfbfb');
            }).blur(function () {
                var $input = jQuery(this);
                var $placeholder = jQuery('.placeholder', $input.parent());

                if ($input.val() == '')
                    $placeholder.css('color', 'transparent');
            });
            this.$searchInput.focus();
        },

        moveToSearch: function (type) {
            var q = this.$searchInput.val().trim();

            if (q != '') {
                var url = '/search?q=' + encodeURIComponent(q);

                if (typeof type != 'undefined' && type == 'article' || type == 'magazine' || type == 'user') {
                    url = url + '&type=' + type;
                }

                window.location = url;
            }
        },

        liveSearch: function (q, _this) {
            if (q == '') {
                _this.$layer.removeClass(_this.layerTypeSearch);
                _this.$layer.addClass(_this.layerTypeGuide);
            } else {
                _this.$layer.removeClass(_this.layerTypeGuide);
                _this.$layer.addClass(_this.layerTypeSearch);
                jQuery.get(B.Config.apiUrl + '/v1/search/live?q=' + encodeURIComponent(q), function (r) {
                    _this.searchTypes.forEach(function (type) {
                        var data = r.data[type];

                        if (data != null && data.length > 0) {
                            var _data = data;
                            data = {};
                            data[type] = _data;
                        } else {
                            data = { nodata: true };
                        }

                        _this.drawLiveSearch(type, data);
                    });
                });
            }
        },

        drawLiveSearch: function (type, data) {
            var $introItem = jQuery('.intro-' + type + '-item');
            $introItem.empty();
            $introItem.html(B.Util.getTemplate('search-pc-intro-item.hbs', data));
            $introItem.find('.item_recommend_title').each(function () {
                jQuery(this).html(jQuery(this).text());
            });
        },

        downSearchArea: function (e) {
            e.preventDefault();
            jQuery('#searchLayer').remove();
            this.$body.removeClass('brunch_suggest');
            this.$layer = null;
        }
    },

    // 모바일 JS
    M: {},

    // 글 뷰에 대한 JS
    Post: {},

    Comment: {},

    Home: {},

    Magazine: {},

    // 연관글
    Related: {},

    // 템플릿
    Templates: {},

    // 알림 JS
    History: {},

    // 설정
    Config: {},

    Sign: {},

    User: null,

    Keyword: {},

    initKeyword: function (callback) {
        var $popularKeyword = jQuery('.popular-keyword');
        var onClass = 'on';

        $popularKeyword.on('click', function () {
            var id = jQuery(this).attr('data-id');
            $popularKeyword.removeClass(onClass);
            jQuery(this).addClass(onClass);
            jQuery('.list_writers_group').hide();
            jQuery('.writer_' + id).show();

            if (callback) {
                callback();
            }
        });

        jQuery('.brunch_keyword_item_button').on('click', function (e) {
            e.preventDefault();
            var url = '/keyword/profile/' + jQuery(this).attr('data-keyword');
            window.open(url, '_blank');
        });

        jQuery('.brunch_keyword_item_more_button').on('click', function (e) {
            e.preventDefault();
            var url = jQuery(this).attr('data-url');
            window.open(url, '_blank');
        });
    },

    getUser: function (callback, force) {

        var callback = callback || function (user, error) {
        };
        var self = this;

        if (this.data && !force) {
            if (B.isDebug()) {
                console.log('Already exist!!', this.data);
            }

            callback(this.data);
            return;
        }

        B.Util.ajax({
            url: B.Config.apiUrl + '/v1/me',
            type: 'get',
            success: function (result) {
                B.User = result.data;

                if (B.isDebug()) console.log(result.data);

                callback(result.data);
            },

            error: function (error) {
                if (B.isDebug()) console.log(error);

                callback(null, error);
            }
        });
    },

    getKakaoLinkData: function (context) {
        var objectType = context.objectType || 'feed';

        var prizeButtonTemplate = [
            {
                title: '자세히 보기',
                link: {
                    mobileWebUrl: context.link,
                    webUrl: context.link
                }
            }
        ];

        var buttonTemplate = [
            {
                title: '웹으로 보기',
                link: {
                    mobileWebUrl: context.link,
                    webUrl: context.link
                }
            },
            {
                title: '앱으로 보기',
                link: {
                    mobileWebUrl: context.link,
                    webUrl: context.link,
                    androidExecParams: context.appContext.appParamString,
                    iosExecParams: context.appContext.appParamString
                }
            }
        ];

        if (context.prize) {
            buttonTemplate = prizeButtonTemplate;
        }

        if (typeof context.kakaoPrefix != 'undefined' && context.kakaoPrefix != '') {
            context.prefix = context.kakaoPrefix;
        }

        if (typeof context.kakaoDescription != 'undefined' && context.kakaoDescription != '') {
            context.description = context.kakaoDescription;
        }

        if (typeof context.kakaoImage != 'undefined' && context.kakaoImage.src != '') {
            context.image = context.kakaoImage;
        }

        var kakaoLinkData = null;

        if (objectType == 'list') {
            kakaoLinkData = {
                objectType: 'list',
                headerLink: {
                    mobileWebUrl: context.link,
                    webUrl: context.link
                },
                contents: context.listContents,
                buttons: buttonTemplate,
                headerImageUrl: context.headerImageUrl,
                headerTitle: context.headerTitle
            };
        } else {
            kakaoLinkData = {
                objectType: 'feed',
                content: {
                    title: context.prefix,
                    description: context.description || '',
                    imageUrl: context.image.src,
                    link: {
                        mobileWebUrl: context.link,
                        webUrl: context.link,
                        androidExecParams: context.appContext.appParamString,
                        iosExecParams: context.appContext.appParamString
                    }
                },
                buttons: buttonTemplate
            };

            if (context.image.width && context.image.height) {
                kakaoLinkData.content.imageWidth = context.image.width;
                kakaoLinkData.content.imageHeight = context.image.height;
            }
        }

        try {
            var userId = jQuery('#articleUserId').val();
            var articleNo = jQuery('#articleNo').val();

            if (userId && articleNo) {
                var serverCallbackArgsObject = {
                    userId: userId,
                    articleNo: articleNo
                };

                kakaoLinkData.serverCallbackArgs = B.Util.stringify(serverCallbackArgsObject);
            }
        } catch (e) {
        }

        return kakaoLinkData;
    },

    isDebug: function () {
        return B.Config.active == 'dev' || B.Config.active == 'local';
    },

    webToApp: function (context, returnContext) {
        if (!context.urlScheme) {
            if (context.flag) {
                switch (context.flag) {
                    case 'view':
                        if (!context.userId || !context.articleNo) {
                            errorParam();
                            return false;
                        }

                        break;
                    case 'profile':
                        if (!context.userId) {
                            errorParam();
                            return false;
                        }

                        break;
                    case 'magazine':
                        if (!context.magazineNo) {
                            errorParam();
                            return false;
                        }

                        break;
                    case 'comment':
                        if (!context.userId || !context.articleNo) {
                            errorParam();
                            return false;
                        }

                        break;
                    case 'search':
                        break;
                    case 'brunchbook':
                        if (!context.brunchbookNo) {
                            errorParam();
                            return false;
                        }

                        break;
                }
            }

            var paramString = '';
            for (var key in context) {
                if (key == 'flag') {
                    paramString += '?';
                } else {
                    paramString += '&';
                }

                paramString += key + '=' + context[key];
            }

            context = {
                urlScheme: 'brunchapp://open' + paramString,
                storeURL: B.UserAgent.isAndroid ? 'market://details?id=com.daumkakao.android.brunchapp' : 'https://itunes.apple.com/app/id1001388574',
                intentUri: 'intent://open' + paramString + '#Intent;scheme=brunchapp;package=com.daumkakao.android.brunchapp;end',
                onUnsupportedCallback: context.onUnsupportedCallback,
                appParamString: paramString.split('?').join(''),
                onAppMissing: context.onAppMissing
            };
        }

        if (returnContext) {
            return context;
        }

        var moveToStore = function (storeURL) {
            window.location = storeURL;
        };

        var willInvokeApp = (typeof context.willInvokeApp === 'function') ? context.willInvokeApp : function () {};
        var onAppMissing = (typeof context.onAppMissing === 'function') ? context.onAppMissing : moveToStore;
        var onUnsupportedCallback = (typeof context.onUnsupportedCallback === 'function') ? context.onUnsupportedCallback : function () {};

        willInvokeApp();

        var isIntentNotSupportedBrowser = B.UserAgent.isFirefox || B.UserAgent.isOpera;

        if (B.UserAgent.isAndroid) {
            if (isIntentNotSupportedBrowser || !!context.useUrlScheme) {
                if (context.storeURL) {
                    web2app_android_scheme(context.urlScheme, context.storeURL, onAppMissing);
                }
            } else if (context.intentUri) {
                web2app_android_intent(context.intentUri, onAppMissing);
            }
        } else if (B.UserAgent.isIOS && context.storeURL) {
            web2app_iOS(context.urlScheme, context.storeURL, onAppMissing);
        } else {
            onUnsupportedCallback();
        }

        function errorParam () {
            alert('파라미터가 올바르지 않음');
        }

        function web2app_iOS (launchURI, storeURL, fallbackFunction) {
            var isIOS9MoreSafari = B.UserAgent.isIOS9MoreSafari;
            var callbackLimitTime = isIOS9MoreSafari ? 3000 : 600;
            var webToAppDelayTime = isIOS9MoreSafari ? 2800 : 400;

            var now = new Date;
            var moveStoreFunc = function () {
                (new Date - now) < callbackLimitTime && fallbackFunction(storeURL);
            };
            var timeFunc = window.setTimeout(function () {
                moveStoreFunc();
            }, webToAppDelayTime);

            if (isIOS9MoreSafari) {
                document.addEventListener('visibilitychange', function clear () {
                    window.clearTimeout(timeFunc);
                    document.removeEventListener('visibilitychange', clear);
                });

                window.location = launchURI;
            } else {
                window.addEventListener('pagehide', function () {
                    window.clearTimeout(timeFunc);
                });

                var iframe = document.createElement('iframe');
                document.body.appendChild(iframe), iframe.style.display = 'none', iframe.setAttribute('src', launchURI);
                iframe.onload = moveStoreFunc;
            }
        }

        function web2app_android_intent (launchURI) {
            /**
             * http://developers.naver.com/docs/utils/mobileapp
             *
             * 네이버앱 6.6.1 이상 버전의 앱에서 앱스킴으로 이동 시 iframe 이용하도록
             * naver userAgent : Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/49.0.2623.110 Safari/537.36 NAVER(inapp; search; 430; 7.0.1)
             */
            var needIframe = B.UserAgent.isNaver661More;

            if (needIframe) {
                var iframe = document.getElementById('androidIntent');

                if (!iframe) {
                    iframe = createHiddenIframe('androidIntent');
                }

                iframe.src = launchURI;
            } else {
                window.location = launchURI;
            }
        }

        function web2app_android_scheme (launchURI, storeURL, fallbackFunction) {
            var clickedAt = new Date().getTime();
            setTimeout(function () {
                var now = new Date().getTime();

                if (isPageVisible() && now - clickedAt < 600) {
                    fallbackFunction(storeURL);
                }
            }, 400);
            var iframe = createHiddenIframe('appLauncher');
            iframe.src = launchURI;
        }

        function isPageVisible () {
            if (typeof document.webkitHidden !== 'undefined') {
                return !document.webkitHidden;
            }

            return true;
        }

        function createHiddenIframe (id) {
            var iframe = document.createElement('iframe');
            iframe.id = id;
            iframe.style.border = 'none';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.display = 'none';
            iframe.style.overflow = 'hidden';
            document.body.appendChild(iframe);
            return iframe;
        }
    },

    encodeQuotes: function (text) {
        return text.replace(/'/g, '%27').replace(/"/g, '%22');
    },

    removeScheme: function (url) {
        if (url != null) {
            if (url.indexOf('http://') >= 0) {
                return url.substring(5);
            }

            if (url.indexOf('https://') >= 0) {
                return url.substring(6);
            }
        }

        return url;
    }
};

jQuery(function () {
    if (!B.UserAgent.isMobile) {
        B.headerMenu.init();
        B.sideMenu.init();
    }
});

(function () {
    try {
        var console = {
            error: function () {},
            log: function () {},
            debug: function () {},
            info: function () {},
            warn: function () {},
            group: function () {},
            groupCollapsed: function () {},
            groupEnd: function () {}
        };

        window.console = window.console || console;
        for (var p in console) {
            if (!window.console[p]) {
                window.console[p] = console[p];
            }
        }

    } catch (e) {

    }
})();

(function ($) {
    $.fn.blink = function () {
        $(this).fadeOut(250).fadeIn(250);
    };

    $.fn.exists = function () {
        return this.size() > 0;
    };

    $.fn.notExists = function () {
        return this.size() == 0;
    };

    $.isUndefinedOrNull = function (target) {
        return typeof (target) == 'undefined' || target == null;
    };

    $.fn.isVisible = function () {
        return $(this).is(':visible');
    };

    $.fn.isHidden = function () {
        return $(this).is(':hidden');
    };

    $.fn.isAnimated = function () {
        return $(this).is(':animated');
    };

    $.fn.isNotAnimated = function () {
        return !$(this).isAnimated();
    };
})(jQuery);
